export default function removeAccents(text: string) {
  return text
    .normalize('NFKD')
    .replaceAll(/[^\x20-\x7F]/g, '');
}
